var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    viewBox: "0 0 28 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0893 20.2006C13.0893 19.7422 13.1638 19.3411 13.3127 18.9972C13.4732 18.6419 13.6623 18.3439 13.8801 18.1033C14.1093 17.8626 14.4073 17.5761 14.774 17.2437C15.2325 16.8425 15.5706 16.4987 15.7883 16.2122C16.0061 15.9142 16.115 15.5589 16.115 15.1463C16.115 14.5847 15.8972 14.1377 15.4617 13.8053C15.0262 13.4615 14.4245 13.2896 13.6566 13.2896C12.3156 13.2896 11.2899 13.7423 10.5793 14.6477L9.32428 13.7538C9.80565 13.1349 10.4188 12.6592 11.1638 12.3269C11.9202 11.9945 12.7913 11.8283 13.7769 11.8283C15.0262 11.8283 16.0176 12.1034 16.7511 12.6535C17.4846 13.1922 17.8513 13.9371 17.8513 14.8884C17.8513 15.3583 17.7711 15.7767 17.6107 16.1434C17.4617 16.4987 17.2783 16.7967 17.0605 17.0374C16.8428 17.2781 16.5505 17.5646 16.1838 17.897C15.7139 18.321 15.3643 18.6935 15.1351 19.0144C14.9173 19.3353 14.8084 19.7307 14.8084 20.2006H13.0893ZM13.966 24.1031C13.6451 24.1031 13.3758 24 13.158 23.7937C12.9517 23.5759 12.8486 23.3123 12.8486 23.0029C12.8486 22.6934 12.9517 22.4356 13.158 22.2293C13.3758 22.0115 13.6451 21.9026 13.966 21.9026C14.2869 21.9026 14.5505 22.0115 14.7568 22.2293C14.9631 22.4356 15.0663 22.6934 15.0663 23.0029C15.0663 23.3123 14.9574 23.5759 14.7397 23.7937C14.5334 24 14.2755 24.1031 13.966 24.1031Z",
    fill: "#F39C12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7533,
    cy: 17.8793,
    r: 13.0657,
    stroke: "#F39C12",
    strokeWidth: 1.37533
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.84965f7e044e7192a13adbc3eae64e65.svg";
export { ForwardRef as ReactComponent };